import { useGetPowerPoint, useGetPowerPointStatus } from "@/api/studio/exports/queries";
import { ExportStatusModal } from "@/components/ui/modal";

/* Prop Types */
interface ExportPowerPointModalProps {
  projectId: string;
  studyId: string;
  taskId: string;
}

/*
 * ExportPowerPointModal
 * Thin wrapper that fetches PowerPoint status/file and hands off state to the
 * generic ExportStatusModal for rendering.
 */
export const ExportPowerPointModal = ({ projectId, studyId, taskId }: ExportPowerPointModalProps) => {
  /* Queries */
  const { data: pptStatus, isLoading: isPptStatusLoading } = useGetPowerPointStatus(projectId, studyId, taskId);
  const { data: ppt, isLoading: isPptLoading, isError: isPptError } = useGetPowerPoint(projectId, studyId, pptStatus?.status === "SUCCEEDED");

  /* Derived state */
  const isLoading = isPptStatusLoading || isPptLoading || pptStatus?.status === "RUNNING";
  const isSuccess = !isLoading && pptStatus?.status === "SUCCEEDED" && !!ppt && !isPptError;
  const isError = !isLoading && !isSuccess;

  /* Render */
  return (
    <ExportStatusModal
      isLoading={isLoading}
      isSuccess={isSuccess}
      isError={isError}
      fileUrl={ppt?.fileUrl}
      loadingTitle="Generating presentation"
      loadingDescription="Please wait while we prepare presentation..."
      successTitle="Presentation is ready"
      errorDescription="We could't prepare your presentation, please try again or contact support"
    />
  );
};
